<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('areaDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
               
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId">
                        {{ data.name || $t('selection') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ selectionGroupName }}</li>
            </ol>
        </nav>
        <div v-for="(group, i) in getCurrentGroup()" :key="i" class="row">
            <div class="mb-3" >
                <div class="row">
                    <div class="mb-3 col-md-4">
                        <label class="form-label" for="name" required>{{ $t('name') }}</label>
                        <input v-model="group.name" type="text" class="form-control" id="name" >
                    </div>
                </div>
                <h4 class="form-label" for="costFactor" required>{{ $t('selectionAreaAssetTypes') }}</h4>
                <div class="row">
                    <div class="mb-3 col-md-12">
                        <div class="row">
                            <div class="col-md-1">
                                <label class="form-label"></label>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{ $t('assetType') }}</label>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{ $t('filterAttributeName') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('filterSign') }}</label>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{ $t('filterValue') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 col-md-12" v-for="(groupAssetType, o) in selectionGroupAssetType" :key="o">
                        <div class="row">
                            <div class="col-md-1">
                                <input class="form-check-input" v-model="groupAssetType.checked" type="checkbox" :id="'checked_' + o">
                            </div>
                            <div class="col-md-3">
                                <select class="form-select" v-model="groupAssetType.assetTypeId" disabled :id="'assetTypeId' + o ">
                                    <option v-for="(assetType,u) in assetTypes" :key="u" v-bind:value="assetType.id">{{assetType.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <select :id="'name_' + o"  class="form-select" v-model="groupAssetType.filterAttributeName" :disabled="!groupAssetType.checked" >
                                    <option disabled>{{ $t('select') }}</option>
                                    <option v-for="(datasetHeader, i) in getDatasetHeaders(groupAssetType)" :disabled="datasetHeader.disabled" :key="i" v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <select v-model="groupAssetType.filterSign" :disabled="!groupAssetType.checked" class="form-select" :id="'filterSign_' + o"> 
                                    <option value=""></option>
                                    <option value="=">=</option>
                                    <option value=">">&gt;</option>
                                    <option value="<">&lt;</option>
                                    <option value=">=">&gt;=</option>
                                    <option value="<=">&lt;=</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <input v-model="groupAssetType.filterValue" :disabled="!groupAssetType.checked" type="text" class="form-control" :id="'filterValue_' + o">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
        <div class="d-grid gap-2 d-md-flex">
            <template v-if="isUserAdmin">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
                <button type="button" class="btn btn-danger" @click="showSelectionGroupDeleteModal = true">{{ $t('delete') }}</button>
            </template>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}` })">{{ $t('back') }}</button>
        </div>
        <SelectionGroupDeleteModal v-if="showSelectionGroupDeleteModal" @reload="confirmGroupDelete()" @closeDeleteDialog="showSelectionGroupDeleteModal = false"/>
    </div>
</template>

<script>
import SelectionApi from "../../../api/server/selection";
import ForecastApi from "../../../api/server/forecast";
import ModelingApi from "../../../api/server/modeling";
import AssetTypeApi from '../../../api/server/assetType';
import SelectionGroupDeleteModal from "./SelectionGroupDeleteModal.vue";
import DatasetApi from '../../../api/server/dataset';
import CheckIfUserIsAdmin from '../../../authCache';

export default {
    name: "selectiondetail",
    watch: {
        $route: "requestData",
    },
    components: {
        SelectionGroupDeleteModal
    },
    mounted() {
        this.requestData();
    },
    methods: {
        getDatasetHeaders(groupAssetType) {
            var headers = [];
            var foundAssetType = this.assetTypes.find(a => a.id == groupAssetType.assetTypeId);
            var foundDataset = this.datasets.find(d => d.id == foundAssetType.datasetId)

            var datasetContent = JSON.parse(foundDataset.content);
            headers = datasetContent["headers"];

            if(headers.findIndex(d => d.name == groupAssetType.filterAttributeName) < 0) {
                headers.push({ name: groupAssetType.filterAttributeName, alias: groupAssetType.filterAttributeName, disabled: true });
            }
            return headers;
        },
        async confirmGroupDelete() {
            this.pending = true;
            this.data.selectionGroup = this.data.selectionGroup.filter(l => l.id != this.$route.params.groupId);
            await SelectionApi.selectionUpdate(this.$route.params.id, this.data);
            this.$router.push({ path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}` });
        },
        getCurrentGroup() {
            var group = this.data.selectionGroup.filter(g => g.id == this.$route.params.groupId);
             if(group.length > 0) {
                this.selectionGroupName = group[0].name;
                return group;
            } 
        },
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsAdmin();

            var selectionId = this.$route.params.selectionId;
            this.data = await SelectionApi.selectionDetail(this.$route.params.id, selectionId);
            var forecast = await ForecastApi.forecastDetail(this.$route.params.id, this.data.forecastId);

            var currentGroup = this.data.selectionGroup.find(g => g.id == this.$route.params.groupId);
            // group multiplicator = LC - forecast 
            var groupMultiplicatorForecast = [];
            for (var o in forecast.forecastAssetTypes) {
                var assetType = forecast.forecastAssetTypes[o];
                // ignore not in groups
                groupMultiplicatorForecast.push({ assetTypeId: assetType.assetTypeId  })
            }

            var selectionGroupAssetTypes = [];
            // for each AT and LC = GROUP
            for(var o in groupMultiplicatorForecast) {
                var object = groupMultiplicatorForecast[o];

                var selectionGroupAssetTypeObject = {
                    checked: false,
                    assetTypeId: object.assetTypeId,
                    filterAttributeName: "",
                    filterSign: "=",
                    filterValue: "",
                    selectionGroupId: this.$route.params.groupId
                }

                var foundSelectionGroupAssetType = currentGroup?.selectionGroupAssetType?.find(v => v.assetTypeId == object.assetTypeId);

                if(foundSelectionGroupAssetType) {
                    selectionGroupAssetTypeObject.id = foundSelectionGroupAssetType.id,
                    selectionGroupAssetTypeObject.checked = true,
                    selectionGroupAssetTypeObject.assetTypeId = foundSelectionGroupAssetType.assetTypeId,
                    selectionGroupAssetTypeObject.filterAttributeName = foundSelectionGroupAssetType.filterAttributeName,
                    selectionGroupAssetTypeObject.filterSign = foundSelectionGroupAssetType.filterSign,
                    selectionGroupAssetTypeObject.filterValue = foundSelectionGroupAssetType.filterValue,
                    selectionGroupAssetTypeObject.selectionGroupId = foundSelectionGroupAssetType.selectionGroupId
                }
                
                selectionGroupAssetTypes.push(selectionGroupAssetTypeObject);
            }
            this.datasets = await DatasetApi.datasetList(this.$route.params.id);

            this.selectionGroupAssetType = selectionGroupAssetTypes;

            var assetTypes = await AssetTypeApi.assetTypeList(this.$route.params.id);
            this.assetTypes = assetTypes.filter(f => forecast.forecastAssetTypes.findIndex(a => a.assetTypeId == f.id) >= 0);

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            this.pending = false;
        },
        async onSubmit() {
            try {
                var selectionGroup = this.data.selectionGroup.find(g => g.id == this.$route.params.groupId);
                if(selectionGroup.name.length > 0) {
                    var selectionGroupAssetTypes = [];

                    for (var i in this.selectionGroupAssetType ) {
                        var assetType = this.selectionGroupAssetType[i];
                        if(assetType.checked) {
                            selectionGroupAssetTypes.push({
                                "id": assetType.id || 0,
                                "selectionGroupId": assetType.selectionGroupId,
                                "assetTypeId": assetType.assetTypeId,
                                "filterAttributeName": assetType.filterAttributeName,
                                "filterSign": assetType.filterSign,
                                "filterValue": assetType.filterValue
                            })
                        }
                    }
                    selectionGroup.selectionGroupAssetType = selectionGroupAssetTypes;
                    
                    await SelectionApi.selectionUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } else {
                    this.showEmptyNameError();
                }
            } catch {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'selectionGroupUpdated',
            type: 'success'
        },
        showError: {
            title: 'error',
            message: 'selectionGroupErrorUpdate!',
            type: 'error'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionGroupName: "",
            assetTypes: [],
            pending: true,
            modelingName: "",
            showSelectionGroupDeleteModal: false,
            selectionGroupAssetType: [],
            datasetHeaders: [],
            missingDatasetFilterHeaders: [],
            datasets: [],
            isUserAdmin: false
        }
    }
};
</script>